<template>
  <div class="comunication-form input-forms">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <span class="required-fields-label">* Preenchimento obrigatório</span>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="50"
            class="inputidlab"
          >
            <md-input-container
              id="txtTitleContainer"
              :class="{ 'md-input-invalid': errors.has('txtTitle') }"
            >
              <label>Título do Aviso *</label>
              <md-input
                id="txtTitle"
                v-model="notification.title"
                v-validate="'required'"
                data-vv-validate-on="none"
                name="txtTitle"
                maxlength="250"
                type="text"
                title
                placeholder="Título do Aviso *"
                @keyup.enter.native="validateBeforeSubmit()"
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>

          <md-layout
            md-flex="45"
            md-flex-medium="45"
            class="inputidlab"
          >
            <md-input-container
              id="txtLinkContainer"
              :class="{ 'md-input-invalid': errors.has('txtLink') }"
            >
              <label>Link</label>
              <md-input
                id="txtLink"
                v-model="notification.link"
                v-validate="'url:require_protocol'"
                data-vv-validate-on="none"
                name="txtLink"
                maxlength="250"
                type="text"
                title
                placeholder="Link"
                @keyup.enter.native="validateBeforeSubmit()"
              />
              <span
                v-if="errors.firstByRule('txtLink', 'url')"
                class="md-error"
              >URL inválida</span>
            </md-input-container>
          </md-layout>
        </md-layout>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="45"
            md-flex-medium="45"
          >
            <md-input-container
              id="dtStartContainer"
              :class="{ 'md-input-invalid': errors.has('dtStart') }"
            >
              <label>Data *</label>
              <date-picker-range
                :date-selected.sync="date"
                :date-filter-alternative="true"
                :calendar-direction="'bottom'"
                :clear-button="false"
                :max-date="null"
                :limit-data="new Date()"
                :default-start-date="today"
                :default-end-date="today"
              />
              <span
                v-if="errors.firstByRule('dtStart', 'required')"
                class="md-error"
              >Obrigatório</span>
              <span
                v-else-if="errors.firstByRule('dtStart', 'check_date_format')"
                class="md-error"
              >Valor
                inválido</span>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50">
            <md-input-container
              id="cboNotificationType"
              :class="{ 'md-input-invalid': errors.has('cboType') }"
            >
              <label>Tipo da Notificação *</label>
              <advanced-select
                id="cboType"
                v-model="notification.type"
                v-validate="'required'"
                :options="typesOptions"
                placeholder="Selecione uma opção"
                name="cboType"
                data-vv-validate-on="none"
                title
              />
              <span
                v-if="errors.firstByRule('dtStart', 'required')"
                class="md-error"
              >Obrigatório</span>
            </md-input-container>
          </md-layout>
        </md-layout>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="40"
            md-flex-medium="50"
            class="radio__container"
          >
            <p>Enviar para:</p>
            <md-radio
              v-model="notification.sendAll"
              :md-value="true"
              @change="clearLaboratoryIds()"
            >
              Todos
            </md-radio>
            <md-radio
              v-model="notification.sendAll"
              :md-value="false"
            >
              Especificar destinatários
            </md-radio>
          </md-layout>
          <md-layout
            md-flex="55"
            md-flex-medium="45"
          >
            <md-input-container
              id="txtLabIdsContainer"
              :class="{ 'md-input-invalid': errors.has('txtLabIds') }"
            >
              <label v-if="!notification.sendAll">Digite os IDs dos destinatários separados por vírgula *</label>
              <md-input
                id="txtLabIds"
                v-model="notification.ids"
                v-validate="'required'"
                :disabled="notification.sendAll"
                data-vv-validate-on="none"
                name="txtLabIds"
                type="text"
                @keyup.enter.native="validateBeforeSubmit()"
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>
        </md-layout>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="75"
            md-flex-medium="75"
          >
            <md-input-container
              id="txtMessageContainer"
              :class="{ 'md-input-invalid': errors.has('txtMessage') }"
            >
              <label>Mensagem *</label>
              <md-textarea
                id="txtMessage"
                v-model="notification.message"
                v-validate="'required'"
                md-autogrow="true"
                data-vv-validate-on="none"
                name="txtMessage"
                maxlength="200"
                type="text"
                title
                placeholder="Mensagem *"
                @keyup.enter.native="validateBeforeSubmit()"
              />
              <span class="md-error">Obrigatório</span>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="25">
            <md-button
              id="btnAdminSubmitFeature"
              class="btn btn-primary comunication-form__submit-button submit-button"
              @click="validateBeforeSubmit"
            >
              SALVAR
            </md-button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>
  </div>
</template>

<script>
import AdvancedSelect from '@/components/common/AdvancedSelect'
import { mapGetters } from 'vuex'
import CardForm from '@/components/common/CardForm'
import { mask } from 'vue-the-mask'
import { scrollToElement } from '@/utils/window-utils'
import comunicationService from '@/api/comunication'
import notify from '@/api/notification'
import DatePickerRange from '@/components/common/DatePickerRange'
import Moment from 'moment'
import strings from '@/strings'

const NOTIFICATION_DEFAULT = {
  title: '',
  message: '',
  link: '',
  enabled: true,
  read: null,
  type: null,
  sendAll: true,
  ids: ''
}

export default {
  name: 'ComunicationForm',
  components: {
    'advanced-select': AdvancedSelect,
    'card-form': CardForm,
    'date-picker-range': DatePickerRange
  },
  directives: {
    mask: mask
  },
  data: () => {
    return {
      typesOptions: strings.notificationTypes,
      notification: NOTIFICATION_DEFAULT,
      date: {
        start: new Date(),
        end: new Date()
      },
      startHour: ' 00:00:00',
      endHour: ' 23:59:59'
    }
  },
  computed: {
    ...mapGetters(['notifications', 'profile']),
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    }
  },
  methods: {
    validateBeforeSubmit(evt) {
      // Abort if user pressed enter + shift
      if (evt && evt.keyCode === 13 && evt.shiftKey) {
        return
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.createNewNotification()
          return
        } else {
          this.analyticsForValidationErrors()
        }

        if (this.errors.items.length) {
          let elementName = this.errors.items[0].field
          let element = ''
          element = document.querySelector('[name="' + elementName + '"]')
          scrollToElement(element)
          element.focus()
        }
      })
    },
    analyticsForValidationErrors() {
      let self = this
      this.errors.all().forEach(function (errorMessage) {
        self.$analytics.pushAnalyticsEvent('error-validation', {
          'msg-error': errorMessage
        })
      })
    },
    preventRawEnterFromPropagation(event) {
      if (
        !event.altKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.metaKey
      ) {
        // Enter without any modifier
        event.preventDefault()
      }
    },
    clearPageData() {
      this.notification = NOTIFICATION_DEFAULT
      window.scrollTo(0, 0)
    },
    createNewNotification() {
      let notification = this.formatNotificationToSave()

      comunicationService.createNotification(notification).then((response) => {
        if (response) {
          this.reload()
          this.clearPageData()
          let sucessMsg = 'Notificação cadastrada com sucesso.'
          notify({
            title: 'AVISO:',
            message: sucessMsg
          })
        }
      })
    },
    formatNotificationToSave() {
      let notification = this.notification

      notification['start-date'] =
        Moment(this.date.start).format('YYYY-MM-DD') + this.startHour
      notification['end-date'] =
        Moment(this.date.end).format('YYYY-MM-DD') + this.endHour
      notification['id-laboratory'] = this.profile.id_laboratory
      notification.type = this.notification.type.value
      if (!notification.sendAll) {
        notification.ids = this.notification.ids.split(',')
      } else {
        notification.ids = []
      }

      return notification
    },
    reload() {
      window.location.reload()
    },
    clearLaboratoryIds() {
      this.notification.ids = ''
    }
  }
}
</script>

<style lang="scss">
@import "../../../../static/stylesheets/mixins";

.comunication-form {
  .card-form__container {
    transition: min-height 600ms, opacity 600ms;
    opacity: 1;
    border-radius: 6px;

    .form-container {
      animation-name: fadein;
      animation-duration: 700ms;
      display: flex;

      .required-fields-label {
        position: absolute;
        right: 5px;
        top: -30px;
        font-size: 12px;
        color: #a80009;
      }

      .tab-label-notification {
        position: absolute;
        right: 180px;
        top: -30px;
        font-size: 12px;
        color: #000;

        strong {
          font-weight: 700;
        }
      }

      .md-layout {
        .md-input-container {
          margin: 0 0 17px;
        }
      }

      .md-input-container,
      .md-input-container.md-input-focused {
        .md-icon {
          color: #c2c2c2;
        }
      }

      .md-input-disabled {
        cursor: not-allowed;

        input {
          color: #ccc;
        }
      }
    }
  }

  .radio {
    &__container {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;

      p {
        margin: auto 0;
        font-size: 16px;
        color: #303030;
      }

      .md-radio {
        margin: auto 0 auto 3.5em;

        &-label {
          color: #7a7a7a;
          text-align: left;
          font-size: 12px;
          font-weight: 500;
          padding-bottom: 10px;
          letter-spacing: 0.8px;
        }
      }
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      background-color: white;
      border: 2px solid white;
    }

    .md-theme-default.md-radio .md-radio-container::after {
      background-color: #7f1a54;
    }
  }

  .comunication-form {
    margin-top: 150px;

    .form-container {
      .md-gutter-24:not(.md-column) {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }

  .multiselect {
    padding-top: 19px;
  }

  #dateFilter {
    margin-left: -10px;
    font-size: 16px;
  }

  .multiselect__single,
  .multiselect__placeholder,
  #datePickerSelect {
    font-size: 16px;
    margin: 0;
    color: #303030;
    margin-top: 4px;
  }

  .advanced-select {
    &__container {
      .multiselect {
        &__single {
          width: 100%;
          color: #303030;
          font-size: 16px;

          @media screen and (-ms-high-contrast: active),
          (-ms-high-contrast: none) {
            margin: 1px 0 0;
          }
        }
      }
    }
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media all and (max-width: 1024px) {
  .comunication-form .card-form__container .submit-button {
    right: 19px;
  }
}

.IE-11 {
  .inputidlab {
    min-width: 30%;
    max-width: 35%;
  }
}
</style>
